import { Stack, Text } from '@chakra-ui/react';
import { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PATHS } from 'router/routes';
import { GetUserAgentIsReady } from 'graphql/queries/GetUserAgentIsReady';
import { useError } from 'error-provider/ErrorProvider';
import { GetUserAgents } from 'graphql/queries/GetUserAgents';
import { useApolloClient, useLazyQuery } from '@apollo/client';
import CreateAgentFormWrapper from '../components/CreateAgentFormWrapper';
import { Loader2Icon } from 'lucide-react';

const Loading = () => {
    const timerId = useRef(null);
    const { showError } = useError();
    // const [value, setValue] = useState(0);

    const router = useNavigate();

    const [agents, setAgents] = useState('');

    const apolloClient = useApolloClient();

    const [fetchAgents] = useLazyQuery(GetUserAgents, {
        onCompleted(data) {
            setAgents(data);
        },
        onError(error) {
            showError(undefined, error);
        },
    });

    useEffect(() => {
        if (!agents) {
            fetchAgents();
        }
    }, [agents, fetchAgents]);

    const agentId = agents?.getUserAgents?.agents[0]?.id ?? '';

    const [getIsAgentReady] = useLazyQuery(GetUserAgentIsReady, {
        fetchPolicy: 'no-cache',
        onCompleted(data) {
            if (data?.getUserAgentIsReady?.isReady) {
                console.log(data);

                apolloClient.cache.modify({
                    id: `AgentType:${agentId}`,
                    fields: {
                        trainingGuide() {
                            return data?.getUserAgentIsReady?.trainingGuide;
                        },
                    },
                });

                router(PATHS.TEST_CHAT);
            }
        },
        onError(error) {
            showError(undefined, error);
        },
    });

    // const text = useMemo(() => {
    //     if (value < 30) {
    //         return "We're analyzing your info...";
    //     } else if (value >= 30 && value < 40) {
    //         return 'About 45 seconds remaining';
    //     } else if (value >= 40 && value < 60) {
    //         return "We're generating detailed instructions for your AI agent...";
    //     } else if (value >= 60 && value < 80) {
    //         return '~30 seconds left';
    //     } else if (value >= 80 && value <= 92) {
    //         return "We're building your agent testing lab...";
    //     } else if (value > 92 && value < 100) {
    //         return 'Almost done';
    //     } else {
    //         return isReady
    //             ? 'Success! Your AI agent is ready for initial testing.  Click the button to enter the testing lab to chat and make edits to your agent.'
    //             : 'Almost done';
    //     }
    // }, [value, isReady]);

    // useEffect(() => {
    //     const timerId = setInterval(() => {
    //         setValue((prev) => prev + 2);
    //     }, 1000);

    //     if (value === 110) {
    //         clearInterval(timerId);
    //         getIsAgentReady();
    //     }

    //     return () => {
    //         clearInterval(timerId);
    //     };
    // }, [value]);

    useEffect(() => {
        timerId.current = setInterval(() => {
            getIsAgentReady({
                onCompleted(data) {
                    if (data?.getUserAgentIsReady?.isReady) {
                        clearInterval(timerId.current);
                        router(PATHS.TEST_CHAT);
                    }
                },
            });
        }, 1000);

        return () => {
            if (timerId.current) {
                clearInterval(timerId.current);
            }
        };
    }, [getIsAgentReady, router]);

    return (
        <CreateAgentFormWrapper
            title='Preparing Your AI Agent'
            description='Simulate a conversation with your Dialzara agent to preview its responses. You can make changes as you go.'
        >
            <Stack spacing='3'>
                <Stack spacing='0' alignItems='center'>
                    <Loader2Icon className='h-16 w-16 animate-spin text-purple-600' />
                    <Text className='mt-4 text-lg'>Loading your AI agent...</Text>
                </Stack>
            </Stack>

            {/* <Stack
                border='1px solid'
                borderRadius='6px'
                borderColor='gray.200'
                bg='white'
                boxShadow='0px 1px 2px 0px gray'
                p='15px'
                alignItems='center'
            >
                <Progress
                    {...(!isReady && { isIndeterminate: true })}
                    value={value}
                    w='full'
                    border='1px solid'
                    borderColor='gray.200'
                    rounded='6px'
                    colorScheme='purple'
                />

                <Text textAlign='center'>{text}</Text>

                <ZaraButton
                    onClick={() => router(PATHS.TEST_CHAT)}
                    w={{ base: '80%', sm: '50%' }}
                    isDisabled={!isReady}
                >
                    <Text mr='10px'>Go to Testing Lab</Text> {!isReady && <Spinner size='sm' />}
                </ZaraButton>
            </Stack> */}
        </CreateAgentFormWrapper>
    );
};

export default Loading;
